import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SdModalDefaultComponent } from '@seb/web-design-system/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'wc-omnibus-recommended-price-modal',
  templateUrl: './omnibus-recommended-price-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdModalDefaultComponent, TranslatePipe]
})
export class OmnibusRecommendedPriceModalComponent {
  @Input() isOpenedRecommendedPriceModal = false;

  @Output() isOpenedRecommendedPriceModalChange = new EventEmitter<boolean>();

  modalClosed(isOpened: boolean): void {
    if (!isOpened) {
      this.isOpenedRecommendedPriceModal = false;
      this.isOpenedRecommendedPriceModalChange.emit(false);
    }
  }
}
